// @flow

import ReconnectingWebSocket from 'reconnecting-websocket'

import { logger } from '../../common'

import { onError, onMessage, onOpen } from '../utils/ws'
import { getSubscriberSocketInfo } from '../utils/restApi'

export default {
  methods: {
    async initWebSocket (subscriberId: string, customerId: string, parentUrl: string): Promise<any> {
      const { wsUri } = await getSubscriberSocketInfo(subscriberId, customerId, parentUrl)

      logger.info(`Initializing web socket via ${wsUri}...`)
      const rws = new ReconnectingWebSocket(wsUri)
      rws.addEventListener('open', onOpen(this.$store))
      rws.addEventListener('message', onMessage(this.$store))
      rws.addEventListener('error', onError(this.$store))
      rws.addEventListener('close', onError(this.$store))
      window.ws = rws

      return rws
    }
  }
}
